
import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';

@Injectable()
export class BettingService {

    constructor(
        private httpService: HttpService) { }

    //获取彩票所需要的所有数据
    //TQQ 2017-01-06
    getLottery(lotteryCode) {
        let url = AppConfig.GetProdUrl() + "/Lottery/GetLottery?lotteryCode=" + lotteryCode;
        return this.httpService.get(url);
    }

    //获取当前期号，上期期号，当前期号结束剩余时间
    //TQQ 2017-01-06
    getIssue(lotteryCode) {
        let url = AppConfig.GetProdUrl() + "/Lottery/GetIssue?lotteryCode=" + lotteryCode;
        return this.httpService.get(url);
    }

    //获取彩票开奖历史
    //TQQ 2017-01-06
    getHistory(lotteryCode) {
        let url = AppConfig.GetProdUrl() + "/Lottery/GetHistory?lotteryCode=" + lotteryCode;
        return this.httpService.get(url);
    }

    //投注
    //TQQ 2017-01-10
    betting(order) {
        let url = AppConfig.GetProdUrl() + "/Lottery/Betting";
        return this.httpService.post(url, order);
    }

    //快钱玩法双面盘投注
    //Tony 2017-12-23
    dollarBetting(order) {
        let url = AppConfig.GetProdUrl() + "/Lottery/KQWFBetting";
        return this.httpService.post(url, order);
    }

    //获取玩法明细
    //TQQ 2017-02-16
    getPlayDetail(detailcode: string) {
        let url = AppConfig.GetProdUrl() + "/Lottery/GetPlayDetail?playDetailCode=" + detailcode;
        return this.httpService.get(url);
    }

    //获取当前彩种的开奖号码
    //TQQ 2017-05-16
    getLotteryOpen(params) {
        let url = AppConfig.GetProdUrl() + "/Lottery/GetLotteryOpen";
        return this.httpService.get(url, params);
    }

    //获取当前快钱玩法详细
    //tony 2017-12-02
    getDollarDetaile(lotteryCode) {

        let url = AppConfig.GetProdUrl() + "/lottery/GetSMPPlayMode?lotteryCode=" + lotteryCode;
        return this.httpService.get(url);
    }

}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/services/betting.service.ts